import { render, staticRenderFns } from "./gc-popup-price-group-select.vue?vue&type=template&id=52f02a88"
import script from "./gc-popup-price-group-select.vue?vue&type=script&lang=js"
export * from "./gc-popup-price-group-select.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-price-group-select.vue?vue&type=style&index=0&id=52f02a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports